// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW13_buttonsContainer__Yt0q6","responseContainer":"HW13_responseContainer__k4tDM","code":"HW13_code__YCpe9","text":"HW13_text__JIrNB","info":"HW13_info__m47jh"};